import React, { useState, useEffect } from 'react';
import solicitudIngresoService from '../services/solicitudIngresoService';
import '../styles/SolicitudIngresoModal.css';

const SolicitudIngresoModal = ({ show, onClose, socia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (show && socia) {
            loadPdfPreview();
        }
        
        // Limpiar URL del blob cuando se cierre el modal
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [show, socia]);

    const loadPdfPreview = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const pdfBlob = await solicitudIngresoService.generatePDF(socia.id);
            const url = URL.createObjectURL(pdfBlob);
            setPdfUrl(url);
        } catch (err) {
            console.error('Error al cargar vista previa:', err);
            setError(err.message || 'Error al cargar la vista previa del documento');
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async () => {
        try {
            const nombreCompleto = `${socia.datosPersonales?.nombres || ''} ${socia.datosPersonales?.apellidos || ''}`.trim();
            await solicitudIngresoService.downloadPDF(socia.id, nombreCompleto);
        } catch (err) {
            console.error('Error al descargar:', err);
            alert('Error al descargar el documento');
        }
    };

    const handleClose = () => {
        if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
        }
        setError(null);
        onClose();
    };

    if (!show) return null;

    return (
        <div className="solicitud-modal-overlay" onClick={handleClose}>
            <div className="solicitud-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="solicitud-modal-header">
                    <h2>Solicitud de Ingreso</h2>
                    <button className="solicitud-close-btn" onClick={handleClose}>×</button>
                </div>

                <div className="solicitud-modal-body">
                    {loading && (
                        <div className="solicitud-loading">
                            <div className="spinner"></div>
                            <p>Cargando vista previa...</p>
                        </div>
                    )}

                    {error && (
                        <div className="solicitud-error">
                            <p>{error}</p>
                            <button onClick={loadPdfPreview} className="btn-retry">
                                Reintentar
                            </button>
                        </div>
                    )}

                    {!loading && !error && pdfUrl && (
                        <div className="solicitud-pdf-container">
                            <iframe
                                src={pdfUrl}
                                title="Vista previa de Solicitud de Ingreso"
                                className="solicitud-pdf-viewer"
                            />
                        </div>
                    )}
                </div>

                <div className="solicitud-modal-footer">
                    <button className="btn-secondary" onClick={handleClose}>
                        Cerrar
                    </button>
                    <button 
                        className="btn-primary" 
                        onClick={handleDownload}
                        disabled={loading || error}
                    >
                        <i className="fas fa-download"></i> Descargar PDF
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SolicitudIngresoModal;
